<template>
  <div class="preset_warp">
    <el-steps
      :active="active"
      finish-status="success"
      align-center
    >
      <el-step title="选择套餐"> 
      </el-step>
      <el-step title="填写订单"></el-step>
      <el-step title="在线支付"></el-step>
      <el-step title="预定完成"></el-step>
    </el-steps>
    <div v-if="active == 2">
      <div class="preset_content md-layout md-gutter ">
        <div class="md-layout-item md-size-66 md-medium-size-66 md-small-size-66 md-xsmall-size-100">
          <preset-order></preset-order>      
        </div>
        <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-33 md-xsmall-size-100">
          <preset-cost></preset-cost>
        </div>
      </div>
      <el-button
        style="margin-top: 12px;"
        type="danger"
        @click="next"
      >去付款</el-button>
    </div>
    <div v-if="active == 3">
      <preset-pay></preset-pay>
        <el-button
        style="margin-top: 12px;"
        type="danger"
        @click="next"
      >完成订单</el-button>
    </div>
  </div>
</template>
<script>
import PresetOrder from './PresetOrder'
import PresetCost from './PresetCost'
import PresetPay from './PresetPay'
export default {
  components:{
    PresetOrder,
    PresetCost,
    PresetPay
  },
  data() {
    return {
      active: 2
    };
  },

  methods: {
    next() {
      if (this.active++ > 2) this.active = 0;
    }
  }
}
</script>
<style lang="scss" scoped>
.preset_warp{
  width: 1120px;
  margin:20px auto;
}
</style>
